require('./brokerAdvancedSearchExplore.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @utils
const { formatText, FormattedText } = require('core/i18n').i18n;

// @components
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { LoadingSection } = require('commonsComponents/loadingSection');
const {
    BrokerSearchResults
} = require('components/broker/brokerSearchResults/brokerSearchResults');
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
const { BrokerNoStockAccountModal }  = require('components/broker/brokerSearchResults/brokerNoStockAccountModal');

// @constants
const {
    TYPE_STOCKS,
    TYPE_PLANS,
    TYPE_WARRANTS,
    TYPE_FUNDS,
    TYPE_ETFS,
    BROKER_ADVANCED_SEARCH_VIEW_ADVANCED_SEARCH_TAB,
    BROKER_ADVANCED_SEARCH_DEFAULT_ALL_VALUE
} = require('constants/index');
const { INVESTMENT_PRODUCTS_LIST } = require('constants/flagBasedFeatures');

// @filter_components
const StocksFilters = require('./typeFilters/stocksFilters');
const PlansFilters = require('./typeFilters/plansFilters');
const WarrantsFilters = require('./typeFilters/warrantsFilters');
const FundFilters = require('./typeFilters/fundsFilters');
const ETFsFilters = require('./typeFilters/etfsFilters');

// @actions
const advancedSearchActions = require('actions/brokerAdvancedSearch');
const brokerSearchAction = require('actions/brokerSearch');
const BrokerClientWarningModalAction  = require('actions/brokerClientWarningModal');

// @utilities
const { capitalizeFirstLetter } = require('utilities/stringHelper');

class BrokerAdvancedSearchExplore extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleToggleAdditionalFilters = this.handleToggleAdditionalFilters.bind(this);
        this.handleProductChange = this.handleProductChange.bind(this);
        this.submitButton = this.submitButton.bind(this);
        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleProductSelect = this.handleProductSelect.bind(this);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);

        this.state = {
            showAdditionalFilters: false,
            validation: {
                // TODO refactor validation logic to put it into the reducer
                stocksNameValid: true,
                etfsNameValid: true
            }
        };
    }

    componentDidMount() {
        const {
            searchState,
            isModalFund,
            handleFieldChange,
            defaultProductType,
            fromPlansTransfer
        } = this.props;

        if (isModalFund) {
            handleFieldChange('activeProduct', TYPE_FUNDS);
        } else if (defaultProductType) {
            handleFieldChange('activeProduct', defaultProductType);
        } else if (fromPlansTransfer) {
            handleFieldChange('activeProduct', TYPE_PLANS);
        }

        if (!searchState.get('allProductsFiltersFetched')) {
            this.props.getFilters();
        }

        this.props.onChangeTab(BROKER_ADVANCED_SEARCH_VIEW_ADVANCED_SEARCH_TAB);
        this.props.checkPersonalInformationData();
    }

    componentDidUpdate() {
        const { searchState, defaultProductType } = this.props;
        const allProductsFiltersFetched = searchState.get('allProductsFiltersFetched');
        const activeProduct = searchState.getIn(['activeProduct']);

        if (!activeProduct && defaultProductType && allProductsFiltersFetched) {
            this.handleFieldChange('activeProduct', defaultProductType);
        }
    }

    componentWillUnmount() {
    const { fromPlansTransfer } = this.props;
        if (!fromPlansTransfer) {
            this.props.clearResults();
        }
    }

    filters(activeProduct) {
        let Filters;

        switch (activeProduct) {
            case TYPE_STOCKS:
                Filters = StocksFilters;
                break;
            case TYPE_FUNDS:
                Filters = FundFilters;
                break;
            case TYPE_PLANS:
                Filters = PlansFilters;
                break;
            case TYPE_ETFS:
                Filters = ETFsFilters;
                break;
            case TYPE_WARRANTS:
                Filters = WarrantsFilters;
                break;
            default:
                break;
        }

        return (
            <Filters
                showAdditionalFilters={this.state.showAdditionalFilters}
                searchState={this.props.searchState}
                searchSimpleState={this.props.searchSimpleState}
                onHandleFieldChange={this.handleFieldChange}
                onHandleProductChange={this.props.handleSearchProduct}
                onHandleSearchReset={this.props.handleSearchReset}
                onHandleToggleAdditionalFilters={this.handleToggleAdditionalFilters}
                validation={this.state.validation}
                embeddedSearch={this.props.embeddedSearch}
            />
        );
    }

    handleFieldChange(field, value) {
        if (
            (field === 'term' && !this.state.validation.stocksNameValid) ||
            (field === 'term' && !this.state.validation.etfsNameValid)
        ) {
            this.setState({ validation: { stocksNameValid: true, etfsNameValid: true } });
        }
        if (field !== 'term' && !this.state.validation.etfsNameValid) {
            this.setState({ validation: { etfsNameValid: true } });
        }
        this.props.handleFieldChange(field, value);
    }

    handleProductChange(product) {
        const { searchState, handleFieldChange } = this.props;
        const isFetched = searchState.getIn(['filters', product.value, 'fetched']);

        if (isFetched) {
            handleFieldChange('activeProduct', product.value);
        }
    }

    handleProductSelect(product) {
        this.props.onHandleProductSelect(product);
    }

    handleSubmit() {
        const {
            searchState,
            getResultsList,
            searchButtonSubmit,
            isExternalPlansTransferOrigin,
            isModalFund,
            embeddedSearch,
            isInternalTransferFund
        } = this.props;

        const isExternalTraspassSearch = isModalFund && !embeddedSearch;
        // Only execute if exists
        !!searchButtonSubmit && searchButtonSubmit();
        const activeProduct = searchState.getIn(['activeProduct']);
        const selectedValues = searchState.getIn(['selectedValues', activeProduct]);
        const isExternalPlansTransfer = !!isExternalPlansTransferOrigin

        if (
            activeProduct === TYPE_STOCKS &&
            !searchState.getIn(['selectedValues', activeProduct, 'term'])
        ) {
            this.setState({ validation: { stocksNameValid: false } });
            return; // TODO handle validation in store
        }
        if (
            activeProduct === TYPE_ETFS &&
            !searchState.getIn(['selectedValues', activeProduct, 'term']) &&
            !this.selectedAnyValue(selectedValues)
        ) {
            this.setState({ validation: { etfsNameValid: false } });
            return; // TODO handle validation in store
        }
        getResultsList(selectedValues, activeProduct, isExternalTraspassSearch, isExternalPlansTransfer, isInternalTransferFund);
        this.setState({ showAdditionalFilters: false });
    }

    handleToggleAdditionalFilters() {
        this.setState({ showAdditionalFilters: !this.state.showAdditionalFilters });
    }

    //Verifica si alguno de los dropdowns tiene valor
    selectedAnyValue(selectedValues) {
        const values = selectedValues
            .filter((v, k) => k !== 'term')
            .filter(v => v !== BROKER_ADVANCED_SEARCH_DEFAULT_ALL_VALUE);
        if (values.size !== 0) return true;
        return false;
    }

    handleSubmitPlan(activeProduct){
        const { searchState, getResultsList } = this.props;
        const selectedValues = searchState.getIn(['selectedValues', activeProduct]);
        getResultsList(selectedValues, activeProduct);
    }

    submitPlanButton(activeProduct){
        const { embeddedSearch } = this.props;
        const className = embeddedSearch ? "broker-advanced-search-explore__embedded" : "broker-advanced-search-explore__full-row-align-right";
        return (
            <div className={className}>
                <OKButton
                    id="btnBrokerAdvancedSearchSubmit"
                    onClick={this.handleSubmitPlan(activeProduct)}
                    modifier="primary"
                >
                    <FormattedText value="broker-advancedSearchSubmit" />
                </OKButton>
            </div>
        );
    }

    submitButton() {
        const { embeddedSearch } = this.props;
        const className = embeddedSearch ? "broker-advanced-search-explore__embedded" : "broker-advanced-search-explore__full-row-align-right";
        return (
            <div className={className}>
                <OKButton
                    id="btnBrokerAdvancedSearchSubmit"
                    onClick={this.handleSubmit}
                    modifier="primary"
                >
                    <FormattedText value="broker-advancedSearchSubmit" />
                </OKButton>
            </div>
        );
    }

    productOptions = () => {
        const { isModal, flagBasedFeatures} = this.props;
        const options = isModal ? [
            TYPE_STOCKS,
            TYPE_ETFS,
            TYPE_WARRANTS
        ] : [
            TYPE_STOCKS,
            TYPE_FUNDS,
            TYPE_PLANS,
            TYPE_ETFS,
            TYPE_WARRANTS
        ];
        return options.filter(e => flagBasedFeatures.get(INVESTMENT_PRODUCTS_LIST).includes(e)).map(type => {
            return {label: formatText(`broker-myInvestments${capitalizeFirstLetter(type)}`), value: type}
        });
    }

    buildContentByDefault() {
        const { searchState, isModalFund, selectedNewFund, embeddedSearch, selectedNewPlan, fromPlansTransfer, watchlistId, plansToFilter, fundsToFilter } = this.props;

        if (!searchState.get('fetchingDone')) {
            return <LoadingSection />;
        }

        const activeProduct = searchState.getIn(['activeProduct']);
        const typeFilters = !!activeProduct ? this.filters(activeProduct) : undefined;
        const submitButton = !!activeProduct ? this.submitButton(activeProduct) : undefined;
        const firstInstructions = !activeProduct
            ? (<div className="broker-advanced-search-explore__first-instruction">
                <FormattedText value="broker-advancedSearchStartInstruction" />
            </div>
        ) : undefined;

        const modalHeader = (this.props.isModal && !embeddedSearch) ? (
            <FormattedText value="broker-advancedSearchModalHeader" className="broker-advanced-search-explore__title" />
        ) : undefined;

        const modalResults = this.props.isModal ? (
            <div>
                <BrokerSearchResults
                    isModal={this.props.isModal}
                    onHandleProductSelect={this.handleProductSelect}
                    embeddedSearch={this.props.embeddedSearch}
                    selectedNewFund={selectedNewFund}
                    isInternalTransferFund={this.props.isInternalTransferFund}
                    fundsToFilter={fundsToFilter}
                />
            </div>)
            : (<div className="broker-advanced-search-explore__results">
                <BrokerSearchResults
                    watchlistId={watchlistId}
                    fromPlansTransfer={fromPlansTransfer}
                    onHandleProductSelect={this.handleProductSelect}
                    embeddedSearch={this.props.embeddedSearch}
                    selectedNewPlan={selectedNewPlan}
                    plansToFilter={plansToFilter}
                    fundsToFilter={fundsToFilter}
                    isInternalTransferFund={this.props.isInternalTransferFund}
                />
            </div>);

        const productSelect = !isModalFund
            ? (<div className="broker-advanced-search-explore__one-third-box">
                <OKSelect
                    id="selBrokerAdvancedSearchProduct"
                    label="broker-advancedSearchProductLabel"
                    name="advanced-search-product"
                    options={this.productOptions()}
                    value={activeProduct}
                    clearable={false}
                    searchable={false}
                    onChange={this.handleProductChange}
                />
            </div>)
            : undefined;

        if (embeddedSearch || fromPlansTransfer) {
            return (
                <div>
                    <div>
                        {typeFilters}
                        {submitButton}
                    </div>
                    {modalResults}
                </div>
            );
        }

        return (
            <div>
                <div className="broker-advanced-search-explore">
                    <div className="broker-advanced-search-explore__full-row">
                        {modalHeader}
                        {productSelect}
                        {firstInstructions}
                    </div>
                    {typeFilters}
                    {submitButton}
                </div>
                {modalResults}
                <BrokerNoStockAccountModal/>
            </div>
        );
    }

    buildContentExternalsFundsTransfer() {
        const { selectedNewFund, embeddedSearch} = this.props;
        const modalHeader = (this.props.isModal && !embeddedSearch) ? (
            <FormattedText value="broker-advancedSearchModalHeader" className="broker-advanced-search-explore__title" />
        ) : undefined;
        const input = (
            <FundFilters
                searchState={this.props.searchState}
                showAdditionalFilters={false}
                onHandleFieldChange={this.handleFieldChange}
                onHandleToggleAdditionalFilters={this.handleToggleAdditionalFilters}
                inputOnly
            />
        );
        const submitButton = (
            <div className="broker-advanced-search-explore__submit-funds-button">
                <OKButton
                    id="btnBrokerAdvancedSearchSubmit"
                    onClick={this.handleSubmit}
                    modifier="primary"
                    block
                >
                    <FormattedText value="broker-advancedSearchSubmit" />
                </OKButton>
            </div>
        );

        const searchResults = (
            <div>
                <BrokerSearchResults
                    isModal={this.props.isModal}
                    onHandleProductSelect={this.handleProductSelect}
                    embeddedSearch={this.props.embeddedSearch}
                    selectedNewFund={selectedNewFund}
                    isExternalFundsTransfer
                    immExternalTransferFund={this.props.immExternalTransferFund}
                />
            </div>
        );

        return(
            <div>
                {modalHeader}
                <div className="broker-advanced-search-explore__input-area">
                    <div className="broker-advanced-search-explore__input">
                        {input}
                    </div>
                    {submitButton}
                </div>
                {searchResults}
            </div>
        )
    }

    render() {
        const { isExternalFundsTransfer } = this.props;
        return !!isExternalFundsTransfer ? this.buildContentExternalsFundsTransfer() : this.buildContentByDefault();
    }
}

BrokerAdvancedSearchExplore.propTypes = {
    searchState: PropTypes.object.isRequired,
    searchSimpleState: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    getFilters: PropTypes.func.isRequired,
    getResultsList: PropTypes.func.isRequired,
    isExternalPlansTransferOrigin: PropTypes.bool,
    clearResults: PropTypes.func,
    handleFieldChange: PropTypes.func.isRequired,
    handleSearchProduct: PropTypes.func.isRequired,
    handleSearchReset: PropTypes.func.isRequired,
    defaultProductType: PropTypes.string,
    onChangeTab: PropTypes.func.isRequired,
    isModal: PropTypes.bool,
    fromPlansTransfer: PropTypes.bool,
    onHandleProductSelect: PropTypes.func,
    isModalFund: PropTypes.bool,
    embeddedSearch: PropTypes.bool,
    selectedNewFund: PropTypes.string,
    selectedNewPlan: PropTypes.string,
    immProfile: PropTypes.object,
    checkPersonalInformationData: PropTypes.func,
    searchButtonSubmit: PropTypes.func,
    watchlistId: PropTypes.string,
    plansToFilter: PropTypes.object,
    fundsToFilter: PropTypes.array,
    isExternalFundsTransfer: PropTypes.bool,
    immExternalTransferFund: PropTypes.object,
    isInternalTransferFund: PropTypes.bool
};

BrokerAdvancedSearchExplore.defaultProps = {
    isInternalTransferFund: false
};

module.exports.BrokerAdvancedSearchExplore = connect(
    state => ({
        searchState: state.brokerAdvancedSearch,
        searchSimpleState: state.brokerSearch,
        immProfile: state.profile,
        immExternalTransferFund: state.externalTransferFund,
    }),
    {
        onChangeTab: advancedSearchActions.changeTab,
        handleFieldChange: advancedSearchActions.handleFieldChange,
        getResultsList: advancedSearchActions.getResultsList,
        clearResults: advancedSearchActions.clearResults,
        getFilters: advancedSearchActions.getFilters,
        handleSearchProduct: brokerSearchAction.searchProduct,
        handleSearchReset: brokerSearchAction.clearResults,
        checkPersonalInformationData: BrokerClientWarningModalAction.checkPersonalInformationData
    }
)(withFeatureToggling(BrokerAdvancedSearchExplore));
